import { createContext } from "react";

const realEstateContext = createContext();

export default realEstateContext;
